/* YOMORE LP animations. Scoped and safe for Dawn theme editor reloads. */
(function(){
 function init(root){
  if(!root || root.dataset.yomoreInitialized==='true')return;
  root.dataset.yomoreInitialized='true';
  var items=root.querySelectorAll('.fade');
  if('IntersectionObserver' in window){
   var observer=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('visible');observer.unobserve(e.target);}})},{threshold:0.08});
   items.forEach(function(el){observer.observe(el);});
  }else{items.forEach(function(el){el.classList.add('visible');});}
 }
 function initAll(scope){(scope || document).querySelectorAll('.yomore-lp').forEach(init);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll();});else initAll();
 document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();
